import { FeatureTag } from "@Components/game";
import HeaderPopover from "@Components/game/header/header-popover";
import Icon from "@Components/generic/icon";
import { Events } from "@Context/common/general/context";
import { AnalyticsEvents, VRHeaderButtonType } from "@Enums/index";
import { faArrowLeft, faClose } from "@fortawesome/pro-solid-svg-icons";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { HeaderButton } from "../styled-components";
interface VRHeaderBackButtonAction {
  label: string;
  onClick: () => void;
  color?: "primary" | "secondary";
  disabled?: boolean;
  sx?: any;
}
export interface IHeaderLeftSection {
  headerButtonType: VRHeaderButtonType | null;
  buttonTitle?: string;
  badge?: string;
  onBackClick?: () => void;
  actions?: VRHeaderBackButtonAction[];
}

const getButtonIconConfig = (buttonType: VRHeaderButtonType | null) => {
  const buttonIconMap: Record<VRHeaderButtonType, { icon: typeof faArrowLeft; fontSize: number }> = {
    [VRHeaderButtonType.BACK]: { icon: faArrowLeft, fontSize: 14 },
    [VRHeaderButtonType.CLOSE]: { icon: faClose, fontSize: 16 },
  };

  const defaultConfig = buttonIconMap[VRHeaderButtonType.BACK];
  return buttonType ? buttonIconMap[buttonType] || defaultConfig : defaultConfig;
};

const HeaderLeftSection = ({
  headerButtonType,
  buttonTitle = "",
  badge,
  onBackClick = () => Events.app.navigateBack.emit(),
  actions = [],
}: IHeaderLeftSection) => {
  const theme = useTheme();

  const { track } = useAnalytics();
  const iconConfig = getButtonIconConfig(headerButtonType);

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <AnimatePresence>
        {headerButtonType && (
          <motion.div
            layout
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -50, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              sx={{
                backdropFilter: `blur(${theme.spacing(2)})`,
                backgroundColor: `${theme.palette.dsSurface.v200}80`,
                border: `1px solid ${theme.palette.dsBase.v200}10`,
                borderRadius: "40px",
                padding: theme.spacing(1),
              }}
            >
              <HeaderButton onClick={onBackClick}>
                <Icon
                  icon={iconConfig.icon}
                  color={theme.palette.dsBase.v200}
                  fontSize={iconConfig.fontSize}
                  sx={{ width: theme.spacing(1.75) }}
                />
              </HeaderButton>
              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ paddingRight: theme.spacing(2) }}>
                {buttonTitle ? (
                  <>
                    <Typography variant="textLg500" color="dsBase.v200">
                      {buttonTitle}
                    </Typography>
                    {badge && <FeatureTag text={badge} />}
                  </>
                ) : (
                  <Skeleton variant="text" width={100} height={20} />
                )}
              </Stack>
            </Stack>
          </motion.div>
        )}
      </AnimatePresence>

      {!headerButtonType && (
        <motion.div layout style={{ display: "flex", alignItems: "center" }}>
          <Box onClick={() => track(AnalyticsEvents.user_avatar_clicked)}>
            <HeaderPopover />
          </Box>
        </motion.div>
      )}
    </Stack>
  );
};

export default HeaderLeftSection;
